import * as R from 'ramda'
import { isActionType, isActionOneOfTypes } from 'helpers/ramda-ext/actions'
import * as Actions from 'store/actions'
import { RegisteredAction } from 'store/actions/index.types'
import { State } from './pricer.types'

const initialState: Readonly<State> = {
  activePackageKey: null
}

// eslint-disable-next-line @typescript-eslint/default-param-last
export default (state: State = initialState, action: RegisteredAction): State => R.cond([
  [
    isActionOneOfTypes([Actions.version.VERSION_CHANGED, Actions.application.SALE_CHANGES]),
    () => R.assoc('activePackageKey', null, state)
  ], [
    isActionType(Actions.package.SELECT_PACKAGE),
    R.compose(
      R.assoc('activePackageKey', R.__, state),
      R.path(['payload', 'idPackage'])
    )
  ], [
    R.T, R.always(state)
  ]
])(action)
